// import Forbidden from 'components/shared/Forbidden'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import selectIsLogged from 'redux/selectors/selectIsLogged'
import selectUserRoles from 'redux/selectors/selectUserRoles'
import Grid from '@mui/material/Grid'
import Navigation from './Navigation'
import { View } from './View'
import Home from './Home'
import DeletePage from './Delete'
import EditPage from './Edit'

interface Props {
  view?: View
  aol?: string
}

const viewToComponent = (view: View): React.ComponentType => {
  switch (view) {
    case View.ADD_USERS:
    case View.DELETE_USERS:
      return DeletePage
    case View.EDIT_USERS:
      return EditPage
    case View.HOME:
    default: return Home
  }
}

const UserAdminMain: FC<Props> = ({ view = View.HOME, aol = '' }) => {
  const isLogged = useSelector(selectIsLogged)
  const userRoles = useSelector(selectUserRoles)

  if (!isLogged || !userRoles.includes('firm-admin')) {
    // return <Forbidden />
  }

  const ViewComponent = viewToComponent(view)

  return (
    <div className='layout-width-constraint'>
      <Grid container spacing={0}>
        <div className='dn db-t w-100'>
          <Grid item xs={12} sm={12}>
            <Navigation view={view} aol={aol} />
          </Grid>
        </div>
        <div className='dn db-d'>
          <div className='fixed left0 pt3 pl7 pr6 h-100 shadow-black-1' style={{ width: 'inherit', maxWidth: '19rem' }}>
            <Navigation view={view} aol={aol} />
          </div>
        </div>
        <Grid item xs={false} md={4} lg={3} />
        <Grid item xs={12} sm={12} md={8} lg={9}>
          <ViewComponent />
        </Grid>
      </Grid>
    </div>
  )
}

export default UserAdminMain
